import { negate } from 'lodash/fp';
import { getNormalizedAttributeValue } from '../../../../helpers/getAttributeValue';

export default {
  check: (sourceItem, targetItem) => negate(getNormalizedAttributeValue)('specialtyShape', targetItem),
  errorMessage: (/* sourceItem, targetItem */) => (
    'Item is specialty shaped'
  ),
};
